/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { SearchLoupeIcon16Light } from './SearchLoupeIcon16Light';
import { SearchLoupeIcon16Regular } from './SearchLoupeIcon16Regular';
import { SearchLoupeIcon16Solid } from './SearchLoupeIcon16Solid';
import { SearchLoupeIcon20Light } from './SearchLoupeIcon20Light';
import { SearchLoupeIcon20Regular } from './SearchLoupeIcon20Regular';
import { SearchLoupeIcon20Solid } from './SearchLoupeIcon20Solid';
import { SearchLoupeIcon24Regular } from './SearchLoupeIcon24Regular';
import { SearchLoupeIcon24Solid } from './SearchLoupeIcon24Solid';
import { SearchLoupeIcon32Regular } from './SearchLoupeIcon32Regular';
import { SearchLoupeIcon64Regular } from './SearchLoupeIcon64Regular';
var sizes = {
    16: {
        light: SearchLoupeIcon16Light,
        regular: SearchLoupeIcon16Regular,
        solid: SearchLoupeIcon16Solid,
    },
    20: {
        light: SearchLoupeIcon20Light,
        regular: SearchLoupeIcon20Regular,
        solid: SearchLoupeIcon20Solid,
    },
    24: {
        regular: SearchLoupeIcon24Regular,
        solid: SearchLoupeIcon24Solid,
    },
    32: {
        regular: SearchLoupeIcon32Regular,
    },
    64: {
        regular: SearchLoupeIcon64Regular,
    },
};
export var SearchLoupeIcon = forwardRef('SearchLoupeIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
